var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "197.2px",
    height: "78.4px",
    viewBox: "0 0 197.2 78.4",
    style: {
      enableBackground: "new 0 0 197.2 78.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000035523597661893649510000005692398171338288287_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2_00000163768139343247171260000004848555905348215431_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,14.4c-4.5,0.1-8.8,2.3-11.3,6.2c-2.3-3.5-5.9-6.2-10.4-6.2c-4.1,0-7.9,2.1-10.3,5.6l-4.4-4.7h-6.3V45 h-2.1c-1.5,0-2.2-1.2-2.2-3.2v-11c0-10.1-5.4-16.3-16-16.3c-9.7,0-16.6,5.1-17,13.2h11.3c0.6-3.1,2.2-4.8,5.4-4.8 s4.5,1.5,4.8,6.9L23,30.7C11.4,31.5,6.5,35.2,6.5,42.6s4.7,11.2,13.9,11c5.6,0,10.1-1.9,12.3-4.7l7.3,4h5.4h1.3h10.3V32.1 c0-5.9,2.5-8.7,5.9-8.7s4.8,1.8,4.8,8.5v20.8h11.4V32.1c0-5.9,2.5-8.7,5.9-8.7c3.4,0,4.8,1.8,4.8,8.5v21h11.6V29.5 C101.5,19.7,96.8,14.4,88.2,14.4z M29.6,37.7c0,5.9-2.3,8.7-6.7,8.7c-0.1,0-0.3,0-0.4,0c-2.3-0.1-4.1-2.1-4-4.4 c0-2.9,2.3-4.4,5.4-4.8l5.7-0.7V37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.2,14.4c-3.7-0.1-7,1.3-9.5,4V0H104v52.8h7.5l3.2-4.1c2.5,3.2,6.3,5,10.4,4.8c10.3,0,17-7.6,17-19.7 C142.2,22,135.4,14.4,125.2,14.4z M122.5,45.3c-4.5,0-7.3-4.1-7.3-11.3s2.8-11.3,7.3-11.3c4.8,0,7.5,4.1,7.5,11.3 S127.5,45.3,122.5,45.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "154.6,0 145.7,0 144.4,10.1 156,10.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,23.5v-8.4h-13.4V4.4l-10.3,2.2l-1.3,8.4h-8.1h-9.7h-1.9v37.9h11.6V23.5h8.1v17.6 c0,9,2.8,12.2,12.5,12.2c1.9,0,4,0,6.5-0.3v-8.5c-1.2,0.1-2.2,0.1-3.1,0.1c-3.5,0-4.1-1-4.1-4.7V23.5H188.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,74.4V63.5h0.9v10.1h6.2v0.7H5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,74.4V63.5h0.9v10.9H14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,74.4l-4.3-10.9h1l3.8,10l3.8-10h1l-4.3,10.9H21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,74.4V63.5h0.9v10.9H28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,74.4V63.5h1l6.6,9.5v-9.5h0.9v10.9h-1l-6.6-9.5v9.5H32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,69c-0.1-2.9,2.1-5.4,4.8-5.7c0.1,0,0.3,0,0.3,0c2.2-0.1,4.3,1.3,4.8,3.5l-0.9,0.3 c-0.4-1.8-2.1-3.1-3.8-2.9c-2.5,0-4.4,1.9-4.4,4.4c0,0.1,0,0.3,0,0.4c-0.3,2.3,1.5,4.5,4,4.8c0.1,0,0.3,0,0.4,0 c2.3,0,4.3-1.9,4.3-4.3c0-0.1,0-0.1,0-0.3H48v-0.7h5.1v5.9h-0.9v-2.6c-0.7,1.8-2.3,2.8-4.3,2.8c-2.9,0-5.3-2.3-5.3-5.3 C42.7,69.1,42.7,69.1,42.7,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,71.3c0-0.4,0.1-0.9,0.1-1.3l0.9,0.3c-0.1,0.3-0.1,0.7-0.1,1c0,1.6,1.3,2.5,3.4,2.5c2.1,0,3.1-0.9,3.1-2.2 c0-1.3-0.9-1.8-2.3-2.2l-1.5-0.3c-2.2-0.6-3.1-1.5-3.1-2.9c0-1.8,1.5-2.9,3.5-2.9c2.1-0.1,4,1.3,4.1,3.4c0,0.1,0,0.3,0,0.3 l-0.9,0.1c0-1.6-1.5-2.9-3.1-2.9h-0.1c-1.6,0-2.6,0.7-2.6,2.1c0,1.3,1,1.9,2.5,2.2l1.5,0.3c2.2,0.4,2.9,1.5,2.9,2.9 c0,2.1-1.9,3.1-4,3.1C60.6,74.5,59,73.2,59,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.7,74.4V63.5h4.1c2.3,0,3.7,1.2,3.7,3.1c0,1.9-1.3,3.1-3.7,3.1h-3.2v4.7C70.6,74.4,69.7,74.4,69.7,74.4z  M70.6,69h3.2c1.8,0,2.6-0.9,2.6-2.3s-0.9-2.3-2.6-2.3h-3.2V69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.4,74.4l-1.3-3.5h-5.3l-1.3,3.4h-1l4.4-10.9H83l4.4,10.9h-1V74.4z M80.1,70.1h4.7l-2.3-5.9L80.1,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,69c-0.1-2.9,1.9-5.4,4.8-5.7c0.1,0,0.3,0,0.3,0c2.3,0,4.4,1.8,4.8,4.1l-0.9,0.3c-0.6-2.5-1.9-3.5-4-3.5 c-2.5,0-4.3,2.1-4.3,4.8c0,2.8,1.8,4.8,4.3,4.8c2.1,0.1,3.7-1.5,4-3.4l0.9,0.3c-0.4,2.3-2.5,4-4.8,3.8c-2.9,0-5.3-2.3-5.1-5.3 C88,69.1,88,69.1,88,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.4,74.4V63.5h7.2v0.7h-6.3v4.1h5.3v0.7h-5.3v4.4h6.5v0.7L100.4,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.3,71.3c0-0.4,0-0.9,0.1-1.3l0.9,0.3c-0.1,0.3-0.1,0.7-0.1,1c0,1.6,1.3,2.5,3.4,2.5s3.1-0.9,3.1-2.2 c0-1.3-0.9-1.8-2.3-2.2l-1.5-0.3c-2.3-0.6-3.1-1.5-3.1-2.9c0-1.8,1.5-2.9,3.5-2.9c2.1-0.1,4,1.3,4.1,3.4c0,0.1,0,0.3,0,0.3 l-0.9,0.1c0-1.6-1.5-2.9-3.1-2.9h-0.1c-1.6,0-2.6,0.7-2.6,2.1c0,1.3,1,1.9,2.5,2.2l1.5,0.3c2.2,0.4,3.1,1.5,3.1,2.9 c0,2.1-1.9,3.1-4,3.1C110.8,74.5,109.3,73.2,109.3,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123,69c-0.1-2.9,1.9-5.4,4.8-5.7c0.1,0,0.3,0,0.3,0c2.3,0,4.4,1.8,4.7,4.1l-0.7,0.3c-0.6-2.5-1.9-3.5-4-3.5 c-2.5,0-4.3,2.1-4.3,4.8c0,2.8,1.8,4.8,4.3,4.8c2.1,0,3.7-1.5,4-3.4l0.9,0.3c-0.4,2.3-2.5,4-4.8,3.8c-2.9,0-5.3-2.3-5.1-5.3 C123,69.1,123,69.1,123,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.3,74.4V63.5h0.9v10.1h6.2v0.7H135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.4,70.3v-6.7h0.9v6.9c0,1.8,1.5,3.2,3.2,3.2c1.8,0,3.2-1.5,3.2-3.2l0,0v-6.9h0.9v6.9 c0,2.3-1.9,4.3-4.3,4.3C145.3,74.4,143.4,72.6,143.4,70.3L143.4,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.9,71.3c0-0.4,0-0.9,0.1-1.3l0.9,0.3c-0.1,0.3-0.1,0.7-0.1,1c0,1.6,1.3,2.5,3.4,2.5s3.1-0.9,3.1-2.2 c0-1.3-0.9-1.8-2.3-2.2l-1.5-0.3c-2.3-0.6-3.1-1.5-3.1-2.9c0-1.8,1.6-2.9,3.5-2.9c2.1-0.1,4,1.3,4.1,3.4c0,0.1,0,0.3,0,0.3 l-0.9,0.1c0-1.6-1.5-2.9-3.1-2.9h-0.1c-1.6,0-2.6,0.7-2.6,2.1c0,1.3,1,1.9,2.5,2.2l1.5,0.3c2.2,0.4,3.1,1.5,3.1,2.9 c0,2.1-1.9,3.1-4,3.1C155.5,74.5,153.9,73.2,153.9,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.1,74.4V64.3h-4v-0.7h8.8v0.7h-4v10.1H167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.9,74.4V63.5h7.3v0.7h-6.3v4.1h5.3v0.7h-5.3v4.4h6.5v0.7L173.9,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.1,73.5v0.9h-0.3c-1.6,0-2.5-0.7-4-3.4l-0.9-1.6h-2.5v4.8h-1V63.4h4.3c2.2,0,3.5,1.2,3.5,2.9 c0,1.6-1.3,2.9-2.9,2.9c-0.1,0-0.3,0-0.4,0l0.7,1.2c1.3,2.3,2.2,2.9,3.2,2.9C191.9,73.5,192.1,73.5,192.1,73.5z M184.3,64.3v4.4 h3.4c1.8,0,2.5-0.9,2.5-2.2c0-1.3-0.9-2.2-2.5-2.2H184.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.2,63.5 0,63.5 0,58.1 5.4,58.1 5.4,59.3 1.2,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197.2,78.4 191.8,78.4 191.8,77.2 196,77.2 196,72.9 197.2,72.9  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/partner_1.079d5a8bfe20c7f045771dbbffd62d0e.svg";
export { ForwardRef as ReactComponent };